import { connect } from '@vfde-sails/core';
import * as mapDispatch from '../App/action';
import {
    State,
    mapStateToProps,
} from '../App/selector';
import {
    mountOptionPicker,
    setOptionPickerState,
} from '../../components/optionPicker';
import {
    updateGigakombiPrice,
    updateYoungPickerText,
} from '../../components/justText';
import {
    DiscountId,
    Kip1000CableMax,
} from '../../enums/elementId';
import { getUpdateFlags } from './update';
import { setElementVisibility } from '../../util/visibility';
import { mountFootnoteLink } from '../../components/footnoteLink';
import {
    mountPromotionalCard,
    updateResidentPlusInnerHTML,
} from '../../components/promotionalCard';
import { mountTooltip } from '../../components/tooltip';
import { isPlaystationPromoActive } from '../../util/cms';

type Actions = typeof mapDispatch;

function container (state: State, actions: Actions) {
    const gigakombiPicker = mountOptionPicker(DiscountId.GIGAKOMBI_PICKER, (value: string) =>
        actions.setGigakombi(value === 'true'));
    const youngPicker = mountOptionPicker(DiscountId.YOUNG_PICKER, (value: string) =>
        actions.setYoung(value === 'true'));
    const tvConnectPicker = mountOptionPicker(DiscountId.TV_CONNECT_PICKER, (value: string) =>
        actions.setTVProductSelection(value === 'true'));
    const residentBonusCard = mountPromotionalCard(DiscountId.RESIDENT_PLUS_CARD);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const {
                isGigakombi,
                isContentEnabled,
                selectedTariff,
                isYoung,
                isResidentPlus,
                isTVProductSelected,
                selectedTVProduct,
            } = newState;
            const { gigakombiDiscount, residentBonus } = selectedTariff || {};
            const update = getUpdateFlags(newState, oldState);

            mountFootnoteLink(DiscountId.GIGAKOMBI_BONUS_TEXT);
            mountFootnoteLink(DiscountId.FREE_WIFI);

            const isPlaystationPromo = selectedTariff ? selectedTariff &&
                                    Object.values(Kip1000CableMax).includes(selectedTariff.id as Kip1000CableMax)
                                    && isPlaystationPromoActive() : false;

            if (update.content) {
                setOptionPickerState(gigakombiPicker, isContentEnabled);
                setOptionPickerState(youngPicker, isContentEnabled);
            }

            setOptionPickerState(youngPicker, isPlaystationPromo ? !isContentEnabled : isContentEnabled);

            if (update.tariff) {
                gigakombiDiscount && updateGigakombiPrice(gigakombiDiscount.price.value);
                selectedTariff && updateYoungPickerText(selectedTariff);
            }

            if (update.residentPlus) {
                setElementVisibility(DiscountId.RESIDENT_PLUS_CARD, isResidentPlus);
            }

            if (update.residentPlusPrice) {
                // Note: Workaround for Promo Card Update
                // residentBonus && residentBonusCard?.update(getResidentCardProps(residentBonus.price.value)); FIXME
                updateResidentPlusInnerHTML(residentBonus?.price.value);
                mountTooltip(DiscountId.RESIDENT_PLUS_CARD_TOOLTIP);
            }

            if (update.gigakombi) {
                gigakombiPicker?.setValue(isGigakombi.toString());
                setElementVisibility(DiscountId.GIGAKOMBI_ADDITIONAL_TEXT, isGigakombi);
            }

            if (update.young) {
                youngPicker?.setValue(isYoung.toString());
                setElementVisibility(DiscountId.YOUNG_ADDITIONAL_TEXT, isYoung);
            }

            if (update.tvProduct) {
                tvConnectPicker?.setValue(isTVProductSelected.toString());
                setElementVisibility(DiscountId.TV_CONNECT_PICKER_WRAPPER, !!selectedTVProduct);
            }
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
